import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
    PageTitle,
    Loading,
    Button,
    Modal,
    Input
} from '../root/components/common'
import { getSagasMsgs } from '../root/selectors'
import { NavLink, withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import '../../assets/leaflet-override.css'
// stupid hack so that leaflet's images work after going through webpack
import marker from 'leaflet/dist/images/marker-icon.png'
import marker2x from 'leaflet/dist/images/marker-icon-2x.png'
import markerShadow from 'leaflet/dist/images/marker-shadow.png'
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
    iconRetinaUrl: marker2x,
    iconUrl: marker,
    shadowUrl: markerShadow
})
import { MapContainer, Marker, Popup, Tooltip, useMap } from 'react-leaflet'
import { useDropzone } from 'react-dropzone'
import * as actions from './actions'
import { getDeviceShortStatusText } from '../../utils'
import * as pdfjsLib from 'pdfjs-dist'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'
import { UserPermissions } from '../../services/permissions'
import {
    CautionIcon,
    GetMarkerIcon,
    getDeviceNameIcon,
    getFlashingIcon,
    getSerialNumberAndDeviceNameIcon,
    getSerialNumberIcon
} from './utils/get-marker-icon'
import { OperationModeIcon } from '../root/components/common/operation-mode-icon'
import classNames from 'classnames'
import DeviceStatusBadge from '../root/components/common/device-status-badge'
import { useReportTypes } from '../root/hooks/useReportTypes'
import { parseFloorplanFilters } from './utils/parse-floor-plan-filters'
import {
    mdiClose,
    mdiPlus,
    mdiFloorPlan,
    mdiRefresh,
    mdiCogOutline,
    mdiTools
} from '@mdi/js'
import Icon from '@mdi/react'
import { enqueueSnackbar } from '../root/actions'
import Cropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'
import { compressBigImage, dataURItoBlob } from '../web-floor-plan/utils'
import { StorageSection, BackdropSection } from './partials'
import { Box, IconButton } from '@material-ui/core'
import { useQuery } from 'react-query'
import { getReportsForHeatmap } from './api/locations-api'
import 'leaflet.heat'
import { useFloorPlanFilters } from '../root/hooks/use-floor-plan-filters'
import { useConnectivityHeatmap } from '../root/hooks/use-connectivity-heatmap'
import { useReportsHeatmap } from '../root/hooks/use-reports-heatmap'
import {
    deleteMapLayer,
    isAlreadyMapLayerAdded,
    isDevicePinMovedAfterLastHeartbeat
} from '../../utils/floor-plan-layer'
import { isSelectedConnectivity } from './utils/connectivity-heatmap'
import { WebButtonsGroup } from './partials/web-buttons-group'
import { CustomDrawer } from '../root/components/common/drawer'
import { FloorPlanDrawer } from './partials/floor-plan-drawer'
import { DEVICE_TYPE } from '../root/constants'

/* ------------------ */

/* const iconPerson = new L.Icon({
    iconUrl: require('../img/marker-pin-person.svg'),
    iconRetinaUrl: require('../img/marker-pin-person.svg'),
    iconAnchor: null,
    popupAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: new L.Point(60, 75),
    className: 'leaflet-div-icon'
}); */
// TODO: make dropzone as a separate component

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        height: '100%',
        justifyContent: 'space-between'
    },
    wrapper: {
        height: 'calc(100% - 120px)',
        width: '75%'
    },
    floorPlanWrapper: {
        height: '100%',
        background: '#DDDDDD',
        borderRadius: '20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    heatmap: {
        display: 'flex',
        alignSelf: 'flex-end',
        marginRight: '16px',
        cursor: 'pointer'
    },
    heatmapText: {
        marginRight: '6px'
    },
    heatmapLoader: {
        width: '40px'
    },
    mapContainerWrapper: {
        position: 'relative',
        width: '100%',
        height: '100%'
    },
    dropzoneWrapper: {
        height: '100%'
    },
    titleButtons: {
        display: 'flex'
    },
    pageTitle: {
        justifyContent: 'space-between'
    },
    modalButtons: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 15
    },
    popupWrapper: {
        fontFamily: theme.fontFamily
    },
    removeLink: {
        fontWeight: 'bold',
        color: theme.error,
        cursor: 'pointer'
    },
    leftTitleButton: {
        marginRight: 8
    },
    popupInfoSections: {
        marginBottom: 4
    },
    popupInfoTitle: {
        marginRight: 8,
        fontWeight: 'bold',
        color: theme.textSecondary
    },
    popupInfoSection: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: 2
    },
    deviceLink: {
        textDecoration: 'none',
        fontWeight: 'bold',
        color: `${theme.primary} !important`
    },
    deviceLinkWrapper: {
        marginBottom: 4
    },
    trapIconActive: {
        width: 15,
        height: 15,
        color: theme.active
    },
    trapIconInactive: {
        width: 15,
        height: 15,
        color: theme.error
    },
    lockMarkers: {
        position: 'absolute',
        right: 16,
        top: 16,
        zIndex: 999
    },
    alignCenter: {
        alignItems: 'center'
    },
    operationModeTitle: {
        marginLeft: 8
    },
    numberToConfirmDelete: {
        textAlign: 'center',
        fontSize: 40,
        fontWeight: 'bold'
    },
    closeIcon: {
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
        cursor: 'pointer'
    },
    mainCropDiv: {
        margin: 10
    },
    editFloorplanIcons: {
        display: 'flex',
        justifyContent: 'center',
        margin: '10px auto',
        width: 'fit-content',
        background: '#fbfbfb',
        boxShadow: '1px 4px 5px 0px rgba(0,0,0,0.3)',
        padding: 10,
        borderRadius: 25
    },
    inputLabel: {
        background: '#3c3c3c',
        padding: '10px 15px',
        borderRadius: 5,
        color: 'white',
        boxShadow: '1px 4px 5px 0px rgba(0,0,0,0.3)',
        fontSize: 14,
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer'
    },
    modalHeader: {
        textAlign: 'center',
        fontSize: '23px',
        fontWeight: 500,
        paddingBottom: '20px',
        color: 'gray'
    },
    modalIcon: {
        marginRight: '50px',
        paddingLeft: '40px',
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer'
    },
    uploadIcon: {
        marginLeft: 10,
        stroke: '#3c3c3c',
        strokeWidth: '1.1px'
    },
    saveButton: {
        margin: '20px auto',
        padding: '0px 60px'
    },
    rotateSlider: {
        textAlign: 'center',
        marginTop: 20
    },
    floorplanIcon: {
        stroke: '#ffffff',
        strokeWidth: 0.2
    },
    inputFile: {
        width: '20%',
        display: 'none'
    },
    icons: {
        margin: '0 auto'
    },
    paragraph: {
        margin: '2px'
    },
    spanIconText: {
        fontWeight: 'bold'
    },
    cropperModalRoot: {
        maxHeight: '90vh',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative'
    },
    secondaryFloorplanBtns: {
        position: 'absolute',
        right: 4,
        bottom: 24,
        zIndex: 999,
        display: 'flex',
        flexDirection: 'column'
    },
    hiddenInput: {
        opacity: 0,
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        cursor: 'pointer'
    },
    tooltip: {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: theme.primary,
        color: theme.textPrimaryReverted,
        border: 'none',
        padding: 10,
        width: 250,
        textWrap: 'wrap',
        textAlign: 'center'
    }
}))

function LocationFloorPlan(props) {
    const classes = useStyles()
    const locationId = props.match.params.locationId
    const { isLoading, theme, locale } = useSelector(state => state.main)
    const sagasMsgs = useSelector(getSagasMsgs)
    const { floorPlan, location, floorPlanDevices } = useSelector(
        state => state.locations
    )
    const { reportSeverityGroups } = useReportTypes()
    const [statusesMap, setStatusesMap] = useState(null)
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
    const [isDraggable, setIsDraggable] = useState(false)
    const [userNumberToConfirmDelete, setUserNumberToConfirmDelete] = useState(
        ''
    )
    const [isConfirmDeleteError, setIsConfirmDeleteError] = useState(false)
    const [isFileRendering, setIsFileRendering] = useState(false)
    const permissions = {
        updateLocation: UserPermissions.location(
            location && location.customer_id
        ).update
    }
    const numberToConfirmDelete = useMemo(
        () => Math.floor(Math.random() * (999 - 100 + 1) + 100),
        [isDeleteModalOpen]
    )
    const [showSerialNumber, setShowSerialNumber] = useState(false)
    const [showDeviceName, setShowDeviceName] = useState(false)
    const [isCropModalOpen, setIsCropModalOpen] = useState(false)
    const [defaultImgSrc, setDefaultImgSrc] = useState('')
    const [rotate, setRotate] = useState(0)
    const [croppedImage, setCroppedImage] = useState(null)
    const [isCropFailed, setIsCropFailed] = useState(false)
    const [isRotateFailed, setIsRotateFailed] = useState(false)
    const [isFileReplacement, setIsFileReplacement] = useState(false)

    const {
        totalFiltersApplied,
        totalHeatmapApplied,
        devicesFilters,
        applyDeviceFilters,
        heatmapFilters,
        applyHeatmapFilter,
        resetHeatmapFilters,
        buildHeatmapParams
    } = useFloorPlanFilters({ locationId })

    useEffect(() => {
        if (!isHeatmapVisible) return

        if (isAlreadyMapLayerAdded(map)) {
            deleteMapLayer(map)
        }

        if (isSelectedConnectivity(heatmapFilters.reportTypes)) {
            showConnectivityHeatmap()
            return
        }

        // Refetch the heatmap data with the current parameters
        showReportsHeatmap()
    }, [heatmapFilters])

    const cropperRef = useRef(null)

    const onCrop = () => {
        const imageElement = cropperRef?.current
        const cropper = imageElement?.cropper
        if (
            cropper !== null &&
            cropper.getCroppedCanvas() !== null &&
            cropper.getCroppedCanvas() !== undefined
        ) {
            const base64 = cropper.getCroppedCanvas().toDataURL()
            setCroppedImage(base64)
        } else {
            return
            // setIsCropFailed(true)
        }
    }

    const onRotate = () => {
        const imageElement = cropperRef?.current
        const cropper = imageElement?.cropper
        if (cropper !== null) {
            cropper.rotateTo(rotate)
        } else {
            setIsRotateFailed(true)
        }
    }

    const renderPDF = file => {
        setIsDeleteModalOpen(false)
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onloadend = () => {
            pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker
            pdfjsLib.getDocument(reader.result).promise.then(pdf => {
                if (pdf.numPages > 0) {
                    pdf.getPage(1).then(page => {
                        const viewportParameters = {
                            scale: 4.0
                        }
                        const viewport = page.getViewport(viewportParameters)
                        const canvas = document.createElement('canvas')
                        const canvasContext = canvas.getContext('2d')
                        canvas.height = viewport.height
                        canvas.width = viewport.width
                        page.render({
                            canvasContext,
                            viewport
                        }).promise.then(() => {
                            dataURItoBlob(canvas.toDataURL('image/jpeg'))
                            dispatch(
                                actions.createFloorPlanRequest({
                                    file: dataURItoBlob(
                                        canvas.toDataURL('image/jpeg')
                                    ),
                                    location_id: location.id,
                                    customer_id: location.customer_id,
                                    isFileReplacement: floorPlan ? true : false
                                })
                            )
                        })
                    })
                }
            })
        }
    }

    const renderFile = file => {
        if (file.type === 'application/pdf') {
            renderPDF(file)
        } else {
            setDefaultImgSrc('')
            setIsFileRendering(true)
            const reader = new FileReader()
            reader.addEventListener('load', () => {
                cropperRef?.current?.replace?.(reader.result.toString() || '')
                setDefaultImgSrc(reader.result.toString() || '')
            })
            reader.readAsDataURL(file)
            reader.addEventListener('error', () => {
                dispatch(
                    enqueueSnackbar({
                        message: locale.locations.somethingWentWrong,
                        options: {
                            variant: 'error'
                        }
                    })
                )
                setIsFileRendering(false)
            })
            setIsCropModalOpen(true)
        }
    }

    const onSelectFile = e => {
        if (e.target.files && e.target.files.length > 0) {
            setRotate(0)
            renderFile(e.target.files[0])
            handleClose()
        }
        e.target.value = null
    }

    const onDrop = useCallback(
        acceptedFiles => {
            acceptedFiles.forEach(file => {
                renderFile(file)
            })
        },
        [location, floorPlan]
    )

    const onSaveFloorplan = async () => {
        const blob = dataURItoBlob(croppedImage ? croppedImage : defaultImgSrc)
        const file = new File([blob], 'floorplan_image', { type: 'image/jpeg' })
        setIsDeleteModalOpen(false)
        try {
            const compressedImage = await compressBigImage(file)
            dispatch(
                actions.createFloorPlanRequest({
                    file: compressedImage,
                    location_id: location.id,
                    customer_id: location.customer_id,
                    isFileReplacement
                })
            )
        } catch (ex) {
            dispatch(
                enqueueSnackbar({
                    message: locale.locations.floorPlanLoadingError,
                    options: {
                        variant: 'error'
                    }
                })
            )
        } finally {
            setIsFileReplacement(false)
            setIsCropModalOpen(false)
        }
    }

    const {
        getRootProps,
        isDragActive,
        isDragAccept,
        isDragReject
    } = useDropzone({
        maxFiles: 1,
        accept: 'image/jpg, image/jpeg, image/png, application/pdf',
        onDrop
    })

    /* DROPZONE CUSTOM STYLES */
    const baseStyle = {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
        borderWidth: theme.borderWidth * 6,
        borderRadius: theme.borderRadius,
        borderColor: theme.secondary,
        borderStyle: 'dashed',
        backgroundColor: theme.background,
        color: theme.textPrimary,
        fontSize: 18,
        outline: 'none',
        transition: 'border .24s ease-in-out',
        height: '100%',
        justifyContent: 'center'
    }

    const activeStyle = {
        borderColor: theme.primary
    }
    const acceptStyle = {
        borderColor: theme.primary
    }
    const rejectStyle = {
        borderColor: theme.error
    }

    const style = useMemo(
        () => ({
            ...baseStyle,
            ...(isDragActive ? activeStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {})
        }),
        [isDragActive, isDragReject, isDragAccept]
    )
    /* ---------------------- */

    const [currentFloorPlanDevices, setCurrentFloorPlanDevices] = useState([])
    const [storageFloorPlanDevices, setStorageFloorPlanDevices] = useState([])
    const [map, setMap] = useState()
    const [activeBlur, setActiveBlur] = useState(false)
    const [backToStoragePin, setBackToStoragePin] = useState()
    const [activeBlurForStorage, setActiveBlurForStorage] = useState(false)
    const [isHeatmapVisible, setIsHeatmapVisible] = useState(false)

    const dispatch = useDispatch()

    const { data: heatmapData, isLoading: isLoadingHeatmap } = useQuery(
        ['reportsForHeatmap', locationId, heatmapFilters],
        () =>
            getReportsForHeatmap({
                locationId,
                ...buildHeatmapParams({ isMobile: false })
            }),
        {
            enabled: true,
            refetchOnWindowFocus: false,
            onError: () =>
                dispatch(
                    enqueueSnackbar({
                        message: sagasMsgs.commonLoadingError,
                        options: {
                            variant: 'error'
                        }
                    })
                )
        }
    )

    const { addConnectivityHeatmap } = useConnectivityHeatmap(
        floorPlanDevices,
        map
    )

    const { addReportsHeatmap } = useReportsHeatmap(
        heatmapData,
        map,
        floorPlan?.id,
        !isSelectedConnectivity(heatmapFilters.reportTypes)
    )

    useEffect(() => {
        setMap(map)
    }, [map])

    const onAddDevices = () => {
        dispatch(actions.setIsAddDevicesToFloorPlanMode(true))
        if (location) {
            dispatch(
                actions.availableDevicesToFloorPlansRequest(
                    location.id,
                    location.customer_id
                )
            )
        }
    }

    const onDelete = () => {
        setRotate(0)
        setUserNumberToConfirmDelete('')
        setIsDeleteModalOpen(true)
        setIsConfirmDeleteError(false)
        setIsCropModalOpen(false)
        setIsCropFailed(false)
        setIsRotateFailed(false)
        setCroppedImage(null)
    }

    const deleteFloorPlan = (id, locationId) => {
        if (Number(userNumberToConfirmDelete) === numberToConfirmDelete) {
            dispatch(actions.deleteFloorPlanRequest(id, locationId))
            setIsDeleteModalOpen(false)
            setIsConfirmDeleteError(false)
        } else {
            setIsConfirmDeleteError(true)
        }
    }

    const handleToggleMarkerDrag = () => {
        setIsDraggable(!isDraggable)
    }

    const onMouseLeaveHandler = e => {
        const element = e.target.getBoundingClientRect()
        const right = element.right
        const testSide = Math.floor(e.clientX) >= Math.floor(right)
        if (backToStoragePin && testSide) {
            backToStoragePin.coordinates.lat = 0
            backToStoragePin.coordinates.lng = 0

            setStorageFloorPlanDevices([
                ...storageFloorPlanDevices,
                backToStoragePin
            ])

            setCurrentFloorPlanDevices(
                currentFloorPlanDevices.filter(item => {
                    return item.id !== backToStoragePin.id
                })
            )
            const isNetworkDevice = backToStoragePin.hasOwnProperty(
                'router_type'
            )
            dispatch(
                actions.updateDeviceOfFloorPlanRequest(
                    isNetworkDevice,
                    backToStoragePin.floor_plan_id,
                    backToStoragePin.id,
                    location.id,
                    {
                        coordinates: null
                    }
                )
            )

            setBackToStoragePin(null)
            setActiveBlurForStorage(false)
        }
    }

    const onDropHandler = e => {
        const parsed = JSON.parse(e.dataTransfer.getData('dragged'))
        dispatch(actions.triggerFlashingEffect(parsed.id))
        const rect = e.target.getBoundingClientRect()
        const coordinates = map.containerPointToLatLng(
            L.point([e.clientX - rect.left, e.clientY - rect.top])
        )
        parsed.coordinates = coordinates

        setStorageFloorPlanDevices(() => {
            return storageFloorPlanDevices.filter(item => parsed.id !== item.id)
        })

        setCurrentFloorPlanDevices([...currentFloorPlanDevices, parsed])
        setActiveBlur(false)
        const isNetworkDevice = parsed.hasOwnProperty('router_type')
        dispatch(
            actions.updateDeviceOfFloorPlanRequest(
                isNetworkDevice,
                floorPlan.id,
                parsed.id,
                location.id,
                {
                    coordinates
                }
            )
        )
    }

    const filterDevices = filters => {
        applyDeviceFilters(filters)
        const { typeFilters, statusFilters } = parseFloorplanFilters(
            filters,
            statusesMap
        )
        let filtered = []
        if (typeFilters.length === 0 && statusFilters.length === 0) {
            filtered = floorPlanDevices
        } else {
            filtered = floorPlanDevices.filter(item => {
                let statusRes = true
                let typeRes = true
                if (statusFilters.length > 0) {
                    const isNetworkDevice = item.hasOwnProperty('router_type')
                    if (isNetworkDevice && item.data?.tti?.status) {
                        const status = item.data.tti.status

                        statusRes = statusFilters.some(sf =>
                            sf.includes(status)
                        )
                    } else {
                        const status = item.last_report_type
                            ? item.last_report_type
                            : '12'

                        statusRes = statusFilters.some(sf =>
                            sf.includes(status)
                        )
                    }
                }
                if (typeFilters.length > 0) {
                    const isNetworkDevice = item.hasOwnProperty('router_type')
                    typeRes =
                        typeFilters.includes(item.device_type) ||
                        (isNetworkDevice &&
                            typeFilters.includes('networkDevice'))
                }
                return statusRes && typeRes
            })
        }
        setStorageAndLocalDevices(floorPlanDevices, filtered)
    }

    const setStorageAndLocalDevices = (floorPlanDevices, filtered) => {
        setStorageFloorPlanDevices(
            floorPlanDevices?.filter(
                item => !item.coordinates || !item.floor_plan_id
            )
        )

        setCurrentFloorPlanDevices(
            filtered?.filter(item => item.coordinates && item.floor_plan_id)
        )
    }

    const showConnectivityHeatmap = () => {
        setIsHeatmapVisible(true)
        addConnectivityHeatmap()
    }

    const showReportsHeatmap = () => {
        setIsHeatmapVisible(true)
        addReportsHeatmap()
    }

    const toggleHeatMap = () => {
        if (isAlreadyMapLayerAdded(map)) {
            deleteMapLayer(map)
            setIsHeatmapVisible(false)
            return
        }

        if (isSelectedConnectivity(heatmapFilters.reportTypes)) {
            showConnectivityHeatmap()
            return
        }

        showReportsHeatmap()
    }

    const onDevicesRefresh = () => {
        dispatch(actions.refreshFloorPlanDevices(locationId))
    }

    useEffect(() => {
        if (isCropFailed || isRotateFailed) {
            dispatch(
                enqueueSnackbar({
                    message: locale.locations.somethingWentWrong,
                    options: {
                        variant: 'error'
                    }
                })
            )
        }
    }, [isCropFailed, isRotateFailed])

    useEffect(() => {
        setIsHeatmapVisible(false)
        setMap(null)

        resetHeatmapFilters()

        dispatch(actions.floorPlanRequest(locationId))
    }, [locationId])

    useEffect(() => {
        return () => {
            dispatch(actions.setIsAddDevicesToFloorPlanMode(false))
        }
    }, [])

    useEffect(() => {
        filterDevices(devicesFilters)
    }, [floorPlanDevices])

    useEffect(() => {
        setStatusesMap(reportSeverityGroups)
    }, [reportSeverityGroups])

    const [anchorEl, setAnchorEl] = useState(null)
    const [isOpenSettings, setIsOpenSettings] = useState(false)

    const handleSettingsClick = () => {
        setIsOpenSettings(true)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleDelete = () => {
        onDelete()
        handleClose()
    }

    const handleReplace = e => {
        setIsFileReplacement(true)
        if (e.target.files && e.target.files.length > 0) {
            setRotate(0)
            renderFile(e.target.files[0])
            handleClose()
        }
        e.target.value = null
    }

    return (
        <div className={classes.container}>
            <div className={classes.wrapper}>
                <PageTitle
                    className={classes.pageTitle}
                    title={locale.locations.floorPlan}
                ></PageTitle>

                {isLoading && <Loading />}
                <Modal
                    className={classes.cropperModalRoot}
                    open={isCropModalOpen}
                    size="lg"
                    style={{ backdropFilter: 'blur(7px)' }}
                    onClose={() => {
                        setDefaultImgSrc('')
                        setIsFileReplacement(false)
                        setIsCropModalOpen(false)
                    }}
                >
                    <span className={classes.closeIcon}>
                        <Icon
                            path={mdiClose}
                            size={1}
                            color={theme.shareIconColor}
                            onClick={() => {
                                setDefaultImgSrc('')
                                setIsFileReplacement(false)
                                setIsCropModalOpen(false)
                            }}
                        />
                    </span>
                    <h3 className={classes.modalHeader}>
                        {locale.locations.editFloorplan}
                    </h3>

                    {defaultImgSrc && (
                        <Cropper
                            src={defaultImgSrc}
                            style={{ height: 400, width: '100%' }}
                            guides={false}
                            crop={onCrop}
                            ref={cropperRef}
                            rotatable={true}
                            autoCropArea={3}
                            viewMode={2}
                            zoomable={true}
                            ready={setIsFileRendering.bind(this, false)}
                        />
                    )}
                    {(!defaultImgSrc || isFileRendering) && (
                        <div
                            style={{
                                position: 'absolute',
                                top: '50%',
                                width: 'calc(100% - 100px)',
                                display: 'flex',
                                justifyContent: 'center'
                            }}
                        >
                            {locale.common.loading}...
                        </div>
                    )}

                    <div className={classes.rotateSlider}>
                        <div>{locale.locations.rotate}</div>
                        <input
                            style={{ width: '250px' }}
                            id="rotate-input"
                            type="range"
                            min="0"
                            max="180"
                            step="1"
                            value={rotate}
                            disabled={!defaultImgSrc}
                            onChange={e => {
                                setRotate(Number(e.target.value))
                            }}
                            onMouseUp={onRotate}
                        />
                    </div>

                    <Button
                        onClick={onSaveFloorplan}
                        className={classes.saveButton}
                    >
                        {locale.locations.save}
                    </Button>
                </Modal>
                {!isLoading && !floorPlan ? (
                    permissions.updateLocation ? (
                        <div className={classes.dropzoneWrapper}>
                            <div
                                {...getRootProps({
                                    style,
                                    className: 'dropzone'
                                })}
                            >
                                <Icon
                                    path={mdiFloorPlan}
                                    size={4}
                                    className={classes.floorplanIcon}
                                />
                                <p className={classes.paragraph}>
                                    {locale.locations.noFloorplan}
                                </p>
                                <p className={classes.paragraph}>
                                    {locale.locations.selectFile}
                                </p>
                                <p style={{ margin: 2, marginBottom: 20 }}>
                                    JPG, PNG, PDF
                                </p>
                                <label className={classes.inputLabel}>
                                    <input
                                        className={classes.inputFile}
                                        type="file"
                                        accept="image/jpg, image/jpeg, image/png, application/pdf"
                                        onChange={onSelectFile}
                                    />
                                    {locale.locations.uploadFloorplan}
                                    <Icon
                                        className={classes.uploadIcon}
                                        path={mdiPlus}
                                        size={1}
                                    />
                                </label>
                            </div>
                            <Modal
                                className={classes.cropperModalRoot}
                                open={isCropModalOpen}
                                size="lg"
                                style={{ backdropFilter: 'blur(7px)' }}
                                onClose={() => {
                                    setDefaultImgSrc('')
                                    setIsCropModalOpen(false)
                                }}
                            >
                                <span className={classes.closeIcon}>
                                    <Icon
                                        path={mdiClose}
                                        size={1}
                                        color={theme.shareIconColor}
                                        onClick={() => {
                                            setDefaultImgSrc('')
                                            setIsCropModalOpen(false)
                                        }}
                                    />
                                </span>
                                <h3 className={classes.modalHeader}>
                                    {locale.locations.editFloorplan}
                                </h3>

                                {defaultImgSrc && (
                                    <Cropper
                                        src={defaultImgSrc}
                                        style={{ height: 400, width: '100%' }}
                                        guides={false}
                                        crop={onCrop}
                                        ref={cropperRef}
                                        rotatable={true}
                                        autoCropArea={3}
                                        viewMode={2}
                                        zoomable={true}
                                        ready={setIsFileRendering.bind(
                                            this,
                                            false
                                        )}
                                    />
                                )}
                                {(!defaultImgSrc || isFileRendering) && (
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            width: 'calc(100% - 100px)',
                                            display: 'flex',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        {locale.common.loading}...
                                    </div>
                                )}

                                <div className={classes.rotateSlider}>
                                    <div>{locale.locations.rotate}</div>
                                    <input
                                        style={{ width: '250px' }}
                                        id="rotate-input"
                                        type="range"
                                        min="0"
                                        max="180"
                                        step="1"
                                        value={rotate}
                                        disabled={!defaultImgSrc}
                                        onChange={e => {
                                            setRotate(Number(e.target.value))
                                        }}
                                        onMouseUp={onRotate}
                                    />
                                </div>

                                <Button
                                    onClick={onSaveFloorplan}
                                    className={classes.saveButton}
                                >
                                    {locale.locations.save}
                                </Button>
                            </Modal>
                        </div>
                    ) : (
                        <div>{locale.locations.noFloorPlan}</div>
                    )
                ) : null}

                {!isLoading && floorPlan && (
                    <>
                        <Box
                            onMouseLeave={onMouseLeaveHandler}
                            draggable
                            onDragOver={e => {
                                e.preventDefault()
                                e.dataTransfer.dropEffect = 'move'
                            }}
                            onDrop={onDropHandler}
                            className={classes.floorPlanWrapper}
                        >
                            <WebButtonsGroup
                                onAddDevices={onAddDevices}
                                handleToggleMarkerDrag={handleToggleMarkerDrag}
                                permissions={permissions.updateLocation}
                                devicesFilters={devicesFilters}
                                filterDevices={filterDevices}
                                isDraggable={isDraggable}
                                locale={locale}
                                toggleHeatmap={toggleHeatMap}
                                isLoadingHeatmap={isLoadingHeatmap}
                                isHeatmapVisible={isHeatmapVisible}
                                showSerialNumber={showSerialNumber}
                                setShowSerialNumber={setShowSerialNumber}
                                heatmapFilters={heatmapFilters}
                                totalFiltersApplied={totalFiltersApplied}
                                totalHeatmapApplied={totalHeatmapApplied}
                                applyHeatmapFilter={applyHeatmapFilter}
                                resetHeatmapFilters={resetHeatmapFilters}
                            />
                            <Box className={classes.mapContainerWrapper}>
                                {activeBlur && <BackdropSection />}
                                <MapContainer
                                    //option to fix safari bug with popups
                                    tap={false}
                                    center={[51.505, -0.09]}
                                    zoom={0}
                                    scrollWheelZoom={true}
                                    crs={L.CRS.Simple}
                                    minZoom={-5}
                                    zoomSnap={0.4}
                                    zoomDelta={0.5}
                                >
                                    <FloorPlanInner
                                        disabled={
                                            !permissions.updateLocation ||
                                            !isDraggable
                                        }
                                        locale={locale}
                                        isConnecivityHeatmapActive={
                                            isSelectedConnectivity(
                                                heatmapFilters.reportTypes
                                            ) && isHeatmapVisible
                                        }
                                        floorPlan={floorPlan}
                                        floorPlanDevices={
                                            currentFloorPlanDevices
                                        }
                                        setMap={setMap}
                                        setBackToStoragePin={
                                            setBackToStoragePin
                                        }
                                        setActiveBlurForStorage={
                                            setActiveBlurForStorage
                                        }
                                        showSerialNumber={showSerialNumber}
                                        showDeviceName={showDeviceName}
                                    />
                                </MapContainer>
                                <div className={classes.secondaryFloorplanBtns}>
                                    <IconButton onClick={onDevicesRefresh}>
                                        <Icon
                                            path={mdiRefresh}
                                            color={theme.primary}
                                            size={1}
                                        />
                                    </IconButton>
                                    {permissions.updateLocation && (
                                        <div>
                                            <IconButton
                                                onClick={handleSettingsClick}
                                            >
                                                <Icon
                                                    path={mdiCogOutline}
                                                    color={theme.primary}
                                                    size={1}
                                                />
                                            </IconButton>
                                            <CustomDrawer
                                                open={isOpenSettings}
                                                handleClose={setIsOpenSettings}
                                            >
                                                <FloorPlanDrawer
                                                    locale={locale}
                                                    theme={theme}
                                                    isShowSerialNumber={
                                                        showSerialNumber
                                                    }
                                                    handleSerialNumberChange={
                                                        setShowSerialNumber
                                                    }
                                                    isShowDeviceName={
                                                        showDeviceName
                                                    }
                                                    handleShowDeviceNameChange={
                                                        setShowDeviceName
                                                    }
                                                    handleReplace={
                                                        handleReplace
                                                    }
                                                    handleDelete={handleDelete}
                                                />
                                            </CustomDrawer>
                                        </div>
                                    )}
                                </div>
                            </Box>
                        </Box>
                        <Modal
                            open={isDeleteModalOpen}
                            setOpen={setIsDeleteModalOpen}
                        >
                            <div>
                                <div>
                                    {locale.locations.deleteFloorPlanModal}
                                </div>
                                <div>
                                    {locale.locations.toDeleteFloorPlanTypeIn}
                                </div>
                                {isDeleteModalOpen && (
                                    <div
                                        className={
                                            classes.numberToConfirmDelete
                                        }
                                    >
                                        {numberToConfirmDelete}
                                    </div>
                                )}
                                <Input
                                    label={locale.common.confirmationCode}
                                    isError={isConfirmDeleteError}
                                    type="text"
                                    setValue={setUserNumberToConfirmDelete}
                                    value={userNumberToConfirmDelete}
                                    onEnter={deleteFloorPlan.bind(
                                        this,
                                        floorPlan.id,
                                        floorPlan.location_id
                                    )}
                                />
                                <div className={classes.modalButtons}>
                                    <Button
                                        onClick={deleteFloorPlan.bind(
                                            this,
                                            floorPlan.id,
                                            floorPlan.location_id
                                        )}
                                    >
                                        {locale.common.ok}
                                    </Button>
                                    <Button
                                        reverted
                                        onClick={setIsDeleteModalOpen.bind(
                                            this,
                                            false
                                        )}
                                    >
                                        {locale.common.cancel}
                                    </Button>
                                </div>
                            </div>
                        </Modal>
                    </>
                )}
            </div>
            <StorageSection
                location={location}
                localFloorPlanDevices={storageFloorPlanDevices}
                setActiveBlur={setActiveBlur}
                activeBlurForStorage={activeBlurForStorage}
            />
        </div>
    )
}

function FloorPlanInner({
    floorPlan,
    floorPlanDevices,
    locale,
    disabled,
    setMap,
    setBackToStoragePin,
    setActiveBlurForStorage,
    showSerialNumber,
    showDeviceName,
    isConnecivityHeatmapActive
}) {
    const map = useMap()

    useEffect(() => {
        setMap(map)
    }, [map])

    useEffect(() => {
        const dataString = `data:${floorPlan.mime_type};base64,${floorPlan.floor_plan}`
        L.imageOverlay(dataString, [
            [0, 0],
            [floorPlan.height, floorPlan.width]
        ]).addTo(map)
        map.fitBounds([
            [0, 0],
            [floorPlan.height, floorPlan.width]
        ])
    }, [floorPlan])

    return floorPlanDevices.map(device => {
        return (
            <DraggableMarker
                showSerialNumber={showSerialNumber}
                showDeviceName={showDeviceName}
                disabled={disabled}
                key={device.id}
                device={device}
                locale={locale}
                setBackToStoragePin={setBackToStoragePin}
                setActiveBlurForStorage={setActiveBlurForStorage}
                isConnecivityHeatmapActive={isConnecivityHeatmapActive}
            />
        )
    })
}

function DraggableMarker({
    device,
    locale,
    disabled,
    setBackToStoragePin,
    setActiveBlurForStorage,
    showSerialNumber,
    showDeviceName,
    isConnecivityHeatmapActive
}) {
    const classes = useStyles()
    const dispatch = useDispatch()
    const { theme } = useSelector(state => state.main)
    const { location, floorPlan } = useSelector(state => state.locations)
    const [position, setPosition] = useState(device.coordinates || null)
    const flashingDeviceId = useSelector(
        state => state.locations.flashingDeviceId
    )
    const [showFlashingMarker, setShowFlashingMarker] = useState(false)
    const markerRef = useRef(null)
    const isNetworkDevice = device.hasOwnProperty('router_type')
    let networkDeviceStatus = 'N/A'
    if (isNetworkDevice && device.data?.tti?.status) {
        networkDeviceStatus =
            device.data.tti.status === 'connected'
                ? locale.common.online
                : locale.common.offline
    }
    const isJerryBaitRat = useMemo(() => {
        return device.device_type === DEVICE_TYPE['jerry-bait-rat']
    }, [device.device_type])
    const serialNumberIcon = getSerialNumberIcon(device)
    const deviceNameIcon = getDeviceNameIcon(device)
    const serialNumberAndDeviceNameIcon = getSerialNumberAndDeviceNameIcon(
        device
    )
    const flashingIcon = getFlashingIcon()

    useEffect(() => {
        let flashingMarkerTimer
        if (flashingDeviceId === device.id) {
            setShowFlashingMarker(true)
            flashingMarkerTimer = setTimeout(() => {
                setShowFlashingMarker(false)
                dispatch(actions.resetFlashingEffect())
            }, 2000)
        }
        return () => {
            if (flashingMarkerTimer) {
                clearTimeout(flashingMarkerTimer)
            }
        }
    }, [flashingDeviceId, device.id, dispatch])

    const { severity } = useReportTypes(device.last_report_type)
    const eventHandlers = useMemo(
        () => ({
            drag() {
                const marker = markerRef.current
                if (marker != null) {
                    const position = marker.getLatLng()
                    setPosition(position)
                }
            },
            dragend() {
                const marker = markerRef.current
                if (marker != null) {
                    const position = marker.getLatLng()
                    setPosition(position)
                    dispatch(
                        actions.updateDeviceOfFloorPlanRequest(
                            isNetworkDevice,
                            floorPlan.id,
                            device.id,
                            location.id,
                            {
                                coordinates: position
                            }
                        )
                    )
                }
            }
        }),
        []
    )

    const onDelete = (floorPlanId, deviceId) => {
        dispatch(
            actions.deleteDeviceFromFloorPlanRequest(
                isNetworkDevice,
                floorPlanId,
                deviceId,
                location.id
            )
        )
        dispatch(
            actions.availableDevicesToFloorPlansRequest(
                location.id,
                location.customer_id
            )
        )
    }

    const floorDeviceIcon = GetMarkerIcon(severity, isNetworkDevice, device)

    /* useEffect(() => {
        PLEASE KEEP IT
        const currentCoordinates = device.coordinates
        console.log({currentCoordinates})
        console.log({position})
        if (currentCoordinates)
        dispatch(
            actions.updateDeviceOfFloorPlanRequest(
                isNetworkDevice,
                floorPlan.id,
                device.id,
                location.id,
                {
                    coordinates: position
                }
            )
        )
    }, [position.lat, position.lng]) */

    // this is for marker out
    useEffect(() => {
        if (!disabled) {
            markerRef.current.addEventListener('mousedown', () => {
                setActiveBlurForStorage(true)
                setBackToStoragePin(device)
            })
        }

        markerRef.current.addEventListener('mouseup', () => {
            setBackToStoragePin(null)
            setActiveBlurForStorage(false)
        })
    }, [disabled])

    return (
        <Marker
            draggable={!disabled}
            eventHandlers={eventHandlers}
            position={position}
            ref={markerRef}
            icon={floorDeviceIcon}
        >
            <Popup minWidth={90} className={classes.popupWrapper}>
                <div className={classes.popupInfoSections}>
                    {device.name && (
                        <div className={classes.popupInfoSection}>
                            <div className={classes.popupInfoTitle}>
                                {locale.common.name}:
                            </div>
                            <div>{device.name}</div>
                        </div>
                    )}
                    <div className={classes.popupInfoSection}>
                        <div className={classes.popupInfoTitle}>
                            {locale.devices.serialNr}:
                        </div>
                        <div>{device.serial_number}</div>
                    </div>
                    {device.last_report_type && (
                        <div className={classes.popupInfoSection}>
                            <div className={classes.popupInfoTitle}>
                                {locale.devices.status}:
                            </div>
                            <div>
                                {getDeviceShortStatusText(device, locale)}
                            </div>
                        </div>
                    )}
                    {device.device_type && (
                        <div className={classes.popupInfoSection}>
                            <div className={classes.popupInfoTitle}>
                                {locale.devices.deviceType}:
                            </div>
                            <div>
                                {locale.devices.deviceTypes[device.device_type]}
                            </div>
                        </div>
                    )}
                    {device.in_maintenance_mode ? (
                        <div
                            style={{
                                marginTop: 4,
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Icon
                                path={mdiTools}
                                size={1}
                                color={theme.primary}
                                style={{ marginRight: 4 }}
                            />
                            {locale.common.maintenanceMode}
                        </div>
                    ) : null}
                    {device.router_type && (
                        <>
                            <div className={classes.popupInfoSection}>
                                <div className={classes.popupInfoTitle}>
                                    {locale.devices.routerType}:
                                </div>
                                <div>{device.router_type}</div>
                            </div>
                            <div className={classes.popupInfoSection}>
                                <div className={classes.popupInfoTitle}>
                                    {locale.devices.status}:
                                </div>
                                <div>{networkDeviceStatus}</div>
                            </div>
                        </>
                    )}
                    {device.operation_mode && (
                        <div
                            className={classNames(
                                classes.popupInfoSection,
                                classes.alignCenter
                            )}
                        >
                            <OperationModeIcon
                                locale={locale}
                                operationMode={device.operation_mode}
                            />
                            <div className={classes.operationModeTitle}>
                                {
                                    locale.devices.operationMode[
                                        device.operation_mode
                                    ]
                                }
                            </div>
                        </div>
                    )}
                    {!isJerryBaitRat ? (
                        <DeviceStatusBadge
                            theme={theme}
                            locale={locale}
                            device={device}
                            severity={severity}
                        />
                    ) : null}
                </div>
                {!device.hasOwnProperty('router_type') && (
                    <div className={classes.deviceLinkWrapper}>
                        <NavLink
                            className={classes.deviceLink}
                            to={`/locations/${device.location_id}/devices/${device.id}`}
                        >
                            {locale.locations.goToDevice}
                        </NavLink>
                    </div>
                )}
                <div>
                    {!disabled && (
                        <span
                            className={classes.removeLink}
                            onClick={onDelete.bind(
                                this,
                                device.floor_plan_id,
                                device.id
                            )}
                        >
                            {locale.locations.removeFromFloorPlan}
                        </span>
                    )}
                </div>
            </Popup>
            {showSerialNumber && !showDeviceName && (
                <Marker position={position} icon={serialNumberIcon} />
            )}
            {showDeviceName && !showSerialNumber && (
                <Marker position={position} icon={deviceNameIcon} />
            )}
            {showDeviceName && showSerialNumber && (
                <Marker
                    position={{
                        ...position,
                        lat: position.lat + 28
                    }}
                    icon={serialNumberAndDeviceNameIcon}
                />
            )}
            {showFlashingMarker && (
                <Marker position={position} icon={flashingIcon} />
            )}
            {isDevicePinMovedAfterLastHeartbeat(device) &&
                isConnecivityHeatmapActive && (
                    <Marker
                        position={{
                            ...device.coordinates,
                            lng: device.coordinates.lng + 20
                        }}
                        icon={CautionIcon}
                    >
                        <Tooltip
                            direction="top"
                            offset={[0, -48]}
                            className={classes.tooltip}
                        >
                            {locale.locations.floorPlanPinCaution}
                        </Tooltip>
                    </Marker>
                )}
        </Marker>
    )
}

export default withRouter(LocationFloorPlan)
